import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { without } from 'lodash';
import { HubsSelectionDialogComponent } from './hubs-dialog/hubs-selection-dialog.component';
import {
  alphanumericSortByName,
  AutoUnsubscribe,
  DIALOG_DEFAULT_CONFIG,
  DialogSize,
  IconNames,
  ValidationService,
} from '../../common';
import { HubBrief } from '../../store/state/administration';
import { HubSelectionItem } from './models';

@Component({
  selector: 'container-hubs-selection',
  templateUrl: './hubs-selection.component.html',
  styleUrls: ['./hubs-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class HubsSelectionComponent {
  @Input() isDataEditable: boolean;
  @Input() title: string;
  @Input() description: string;
  @Input() userRoles: string;

  @Input() set hubs(data: HubSelectionItem[]) {
    if (data) {
      this.hubList = alphanumericSortByName([...data]);
    }
  }

  @Output() listChange = new EventEmitter<HubSelectionItem[]>();

  hubList: HubSelectionItem[];
  subscriptions: Subscription[] = [];
  iconNameList = IconNames;
  constructor(public validationService: ValidationService, private dialog: MatDialog, private cd: ChangeDetectorRef) {}

  removeHub(hub: HubSelectionItem): void {
    this.hubList = [...without(this.hubList, hub)];
    this.listChange.emit(this.hubList);
    this.cd.markForCheck();
  }

  manageHubs(): void {
    this.dialog
      .open(HubsSelectionDialogComponent, {
        data: this.hubList,
        ...DIALOG_DEFAULT_CONFIG,
        width: DialogSize.LG,
      })
      .afterClosed()
      .subscribe(({ selected, deleted }: { selected: HubBrief[]; deleted: number[] }) => {
        if (selected) {
          const newHubs = selected.map(({ id, name }: HubBrief) => ({
            id,
            name,
          }));

          const newHubIds: number[] = [];
          const hubListIds: number[] = [];

          newHubs.forEach((hub: HubSelectionItem) => newHubIds.push(hub.id));
          this.hubList.forEach((hub: HubSelectionItem) => hubListIds.push(hub.id));

          newHubIds.forEach((id: number, index: number) => {
            if (!hubListIds.includes(id)) {
              this.hubList = [...this.hubList, newHubs[index]];
            }
          });

          this.hubList.forEach((hub: HubSelectionItem) => {
            if (deleted.includes(hub.id)) {
              this.removeHub(hub);
            }
          });

          this.listChange.emit(this.hubList);
          this.cd.markForCheck();
        }
      });
  }
}
